/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var acc = document.getElementsByClassName("accordion");
var i;
for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;
        if (panel.style.maxHeight){
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
    // hacks for by defaulting to open
    if (acc[i].classList.contains('open')) {
        acc[i].click();
    }
}


function addItemToCart(evntTarget, variant_id, qty) {

    var chkmrkIcon = `
    <svg class="Icon Icon--checkmark h-4" role="presentation" viewBox="0 0 24 24">
        <polygon fill="currentColor" points="9,20 2,13 5,10 9,14 19,4 22,7 "></polygon>
    </svg>
    `;
    let textContent = evntTarget.innerHTML;
    evntTarget.innerHTML = chkmrkIcon;
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    fetch(window.routes.cartAddUrl+".js", {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ "id": variant_id, "quantity": qty })}
    )
    .then(function (data) {
        evntTarget.innerHTML = textContent;
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
        }));
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        document.getElementById('cartToggler').click();
    })
    .catch(function (error) {
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
        console.log('Request failed', error);
    });
}

window.addEventListener('DOMContentLoaded', (event) => {
    window.addEventListener('click', function(e) {
        if (e.target.dataset) {
            let action = e.target.dataset.action;
            switch (action) {
                case 'atc':
                    addItemToCart(e.target, e.target.dataset.var_id, e.target.parentElement.querySelector('input').value || 1);
                    break;
                case 'inc-qty':
                    var inpq = e.target.parentElement.querySelector('input');
                    inpq.value = parseInt(inpq.value) + 1;
                    break;
                case 'dec-qty':
                    var inpq = e.target.parentElement.querySelector('input');
                    let newValue = parseInt(inpq.value) - 1;
                    //validate
                    if (newValue >= 1) {
                        inpq.value = parseInt(inpq.value) - 1;
                    }
                    break;
                default:
                    break;
            }
        }
    });
});
